import BasePopupFormBuilder from "./BasePopupFormBuilder";

export class FormBuilder_m10gaq1y1ibg4cs extends BasePopupFormBuilder {
    constructor(
        {
            submitText = 'Schedule Now'
        } = {}
    ) {
        super({
            formAction: '/wp-content/themes/zerif-pro/submitPersonalDemo.php',
            formName: 'm10gaq1y1ibg4cs',
            title: 'Book Your Live Demo',
            description: 'Just fill out the form to schedule your own online demo.<br> No hassles, no catches.',
            submitText,
        });
    }

    build(
        {
            container,
        }
    ) {
        super.build({
            container,
        });

        container.querySelector('.just-fill')?.remove()

        /** @type {HTMLElement|null} */
        const countryInput = container.querySelector('form .country-input');
        if (countryInput) {
            countryInput.name = 'Field19'
        }
    }
}
